import { Controller } from 'stimulus';
import localDb from '../helpers/localDb';

const STORAGE_KEY = 'site-alert';

class SiteAlert extends Controller {
  connect() {
    if (!('localStorage' in window)) {
      return;
    }

    if (!localDb.get(STORAGE_KEY)) {
      this.element.removeAttribute('hidden');
    }
  }

  onClose() {
    this.element.style.display = 'none';

    const ttlInHours = parseInt(this.data.get('close-ttl'), 10);
    const millisecondsPerHour = 3600000;
    const ttlInMilliseconds = ttlInHours * millisecondsPerHour;

    localDb.set(STORAGE_KEY, 1, ttlInMilliseconds);
  }
}

SiteAlert.targets = [
  //
];

export default SiteAlert;
